import { Component, OnInit } from '@angular/core';
import { EditBookModel } from '../../../models/inModels/Book';
import { Message, SelectItem } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../services/system/storage.service';
import { BookService } from '../../../services/book.service';

@Component({
  selector: 'app-book-edit',
  templateUrl: './book-edit.component.html',
  styleUrls: ['./book-edit.component.css']
})
export class BookEditComponent implements OnInit {

  id;
	model: EditBookModel;
	loading = false;
	error: Message[];
	uploading = false;
	books;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private service: BookService,
		private storageService: StorageService
  ) { 
    this.id = this.route.snapshot.paramMap.get('Id');
  }

  ngOnInit() {
    this.getBook();
  }

  getBook() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditBookModel(result);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  goBack(): void {
		this.router.navigate(['/books']);
  }
  
  
	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditBookModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }
  
  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.coverId = result.PublicId;
		this.loading = false;
  }
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.coverId = null;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/book/book-edit/book-edit.component.ts